var map = {
	"./B": [
		97347,
		9,
		45848,
		25074,
		22951,
		56158,
		70174,
		97347
	],
	"./B/": [
		97347,
		9,
		45848,
		25074,
		22951,
		56158,
		70174,
		97347
	],
	"./B/B.module.scss": [
		37273,
		7,
		22951,
		37273
	],
	"./B/index": [
		97347,
		9,
		45848,
		25074,
		22951,
		56158,
		70174,
		97347
	],
	"./B/index.tsx": [
		97347,
		9,
		45848,
		25074,
		22951,
		56158,
		70174,
		97347
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 31074;
module.exports = webpackAsyncContext;